import React from 'react';

function NotFoundPage() {
  return (
    <div className="NotFoundPage">
      <h1>404 - Not Found</h1>
    </div>
  );
}

export default NotFoundPage;
